@if (showProgressBar) {
  <mat-progress-bar
    mode="indeterminate"
    color="primary"
  ></mat-progress-bar>
}
<div fxLayout="row" fxLayoutAlign="center none" class="profile-form">
  <form
    (ngSubmit)="submit()"
    novalidate
    [formGroup]="profileForm"
    fxFlex="60"
    fxFlex.lt-md="95"
    fxLayout="column"
    fxLayoutAlign="center stretch"
    >
    <div class="required">Required *</div>
    <mat-form-field class="profile-form__firstName">
      <mat-label>First Name</mat-label>
      <input
        matInput
        trimInput
        type="text"
        formControlName="firstName"
        required
        />
      @if (validate('firstName', 'required')) {
        <mat-error>
          First name is required
        </mat-error>
      }
      @if (
        validate('firstName', 'minlength') &&
        profileForm.get('firstName')?.touched
        ) {
        <mat-error
          >
          Minimum of 1 character
        </mat-error>
      }
      @if (
        validate('firstName', 'maxlength') &&
        profileForm.get('firstName')?.touched
        ) {
        <mat-error
          >
          Maximum of 128 characters
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="profile-form__lastName">
      <mat-label>Last Name</mat-label>
      <input
        matInput
        trimInput
        type="text"
        formControlName="lastName"
        required
        />
      @if (validate('lastName', 'required')) {
        <mat-error>
          Last name is required
        </mat-error>
      }
      @if (
        validate('lastName', 'minlength') &&
        profileForm.get('lastName')?.touched
        ) {
        <mat-error
          >
          Minimum of 2 characters
        </mat-error>
      }
      @if (
        validate('lastName', 'maxlength') &&
        profileForm.get('lastName')?.touched
        ) {
        <mat-error
          >
          Maximum of 128 characters
        </mat-error>
      }
    </mat-form-field>

    <!-- Time Zone -->
    <mat-form-field class="profile-form__timezone">
      <mat-label>Timezone</mat-label>
      <mat-select formControlName="timezone">
        @for (tz of timezones; track tz) {
          <mat-option
            class="edit-profile-option"
            [value]="tz.abbreviation"
            >
            {{ tz.name }}
          </mat-option>
        }
      </mat-select>
      @if (validate('timezone', 'required')) {
        <mat-error>
          Timezone is required
        </mat-error>
      }
    </mat-form-field>

    <!-- State -->
    <mat-form-field>
      <mat-label>State</mat-label>
      <mat-select formControlName="state">
        @for (state of usStates; track state) {
          <mat-option
            class="edit-profile-option"
            [value]="state.abbreviation"
            >
            {{ state.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="button-row">
      <button
        type="button"
        class="standard-outline-button button-small"
        (click)="cancel()"
        >
        Close
      </button>

      <button
        type="submit"
        class="standard-button button-small button-background-teal"
        [disabled]="disableUpdateButton()"
        >
        Update User Settings
      </button>
    </div>
  </form>
</div>
